import { c as _c } from "react/compiler-runtime";
import { FC } from 'react';
import { ICONS_MAP } from '@/components/BlogPage/SocialLinks/icons-map';
import Link from '@/components/Link';
import HorizontalFadeScroller from '@/components/shared/HorizontalFadeScroller';
import { StrapiSocial } from '@/types/common';
import css from './style.module.scss';
interface Props {
  socials: StrapiSocial[];
}
const SocialLinks: FC<Props> = t0 => {
  const $ = _c(4);
  const {
    socials
  } = t0;
  let t1;
  if ($[0] !== socials) {
    t1 = socials.map(_temp);
    $[0] = socials;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <HorizontalFadeScroller><ul className={css.socialLinks}>{t1}</ul></HorizontalFadeScroller>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default SocialLinks;
function _temp(social) {
  return <li key={social.id} className={css.listItem}><Link className={css.link} href={social.url} target="_blank" rel="noopener noreferrer"><img className={css.icon} src={ICONS_MAP[social.name]} alt={social.name || ""} width={20} height={20} /></Link></li>;
}